export default __webpack_public_path__ + "static/media/banner3-2-resized2.f5d6979a.png";